(() => {
  const QUIZ_PATH_MATCH = /hair-quiz/;
  if (!QUIZ_PATH_MATCH.test(window.location.pathname)) return;

  let previousCount = 0;
  let initialized = false;

  const isVisible = () => document.visibilityState === 'visible';

  const getCartCount = async () => {
    try {
      const res = await fetch('/cart.js');
      const data = await res.json();
      return data.item_count || 0;
    } catch (err) {
      return previousCount;
    }
  };

  const replaceCartDrawer = (htmlString) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, 'text/html');
    const newDrawer = doc.querySelector('#CartDrawer, cart-drawer, .cart-drawer');
    const oldDrawer = document.querySelector('#CartDrawer, cart-drawer, .cart-drawer');
    if (newDrawer && oldDrawer) {
      oldDrawer.outerHTML = newDrawer.outerHTML;
    }
  };

  const updateCartCount = (htmlString, count) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, 'text/html');
    const targets = document.querySelectorAll('.cart-count-bubble, .cart-count-bubble span, [data-cart-count], .cart-icon__count');
    targets.forEach((el) => {
      el.textContent = count;
      el.innerText = count;
      if (el.hasAttribute('data-cart-count')) el.setAttribute('data-cart-count', count);
    });
  };

  const refreshCartContent = async () => {
    try {
      const res = await fetch('/?sections=cart-drawer,cart-icon-bubble');
      const sections = await res.json();
      if (sections['cart-drawer']) replaceCartDrawer(sections['cart-drawer']);
      if (sections['cart-icon-bubble']) {
        const count = await getCartCount();
        updateCartCount(sections['cart-icon-bubble'], count);
      }
    } catch (err) {
      // swallow errors to avoid blocking UX
    }
  };

  const openDrawer = () => {
    const drawer = document.querySelector('#CartDrawer, .cart-drawer, cart-drawer');
    if (drawer) {
      const isOpen = drawer.classList.contains('active') || drawer.classList.contains('is-open') || drawer.classList.contains('open') || drawer.getAttribute('aria-hidden') === 'false' || drawer.style.display === 'block';
      if (isOpen) return;
    }
    setTimeout(() => {
      const cartIcon = document.querySelector('.cart-icon-bubble, [data-cart-drawer], .header__icon--cart, #cart-icon-bubble');
      if (cartIcon) {
        cartIcon.click();
        return;
      }
      const dawnCart = document.querySelector('cart-drawer');
      if (dawnCart && dawnCart.open) {
        dawnCart.open();
        return;
      }
      const directDrawer = document.querySelector('#CartDrawer, .cart-drawer, cart-drawer');
      if (directDrawer) {
        directDrawer.classList.add('active', 'is-open', 'animate');
        directDrawer.setAttribute('aria-hidden', 'false');
        const overlay = document.querySelector('.drawer__overlay, .cart-drawer__overlay');
        if (overlay) overlay.classList.add('active');
      }
    }, 300);
  };

  const refreshAndOpen = async () => {
    await refreshCartContent();
    openDrawer();
  };

  const monitor = () => {
    const check = async () => {
      if (!isVisible()) return;
      const count = await getCartCount();
      if (initialized && count > previousCount) {
        previousCount = count;
        refreshAndOpen();
      } else if (!initialized) {
        initialized = true;
        previousCount = count;
      } else {
        previousCount = count;
      }
    };
    check();
    setInterval(check, 4000);
  };

  const bindAddEvents = () => {
    document.addEventListener('submit', (e) => {
      const form = e.target.closest('form');
      if (form && (form.action.includes('/cart/add') || (form.getAttribute('action') || '').includes('/cart/add'))) {
        setTimeout(refreshAndOpen, 800);
      }
    }, true);

    document.addEventListener('click', (e) => {
      const btn = e.target.closest('button, [type="submit"], [data-add-to-cart]');
      if (!btn) return;
      const text = (btn.textContent || '').toLowerCase();
      if (btn.name === 'add' || /add|cart/.test(text)) {
        setTimeout(refreshAndOpen, 800);
      }
    }, true);

    document.addEventListener('visibilitychange', () => {
      // No action needed; monitor uses visibility guard.
    });
  };

  document.addEventListener('DOMContentLoaded', () => {
    monitor();
    bindAddEvents();
  });
})();
